import { render } from "./UserBlock.vue?vue&type=template&id=440dd1d8&scoped=true"
import script from "./UserBlock.vue?vue&type=script&lang=js"
export * from "./UserBlock.vue?vue&type=script&lang=js"

import "./UserBlock.vue?vue&type=style&index=0&id=440dd1d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-440dd1d8"]])

export default __exports__